import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Typography } from '@material-ui/core';

import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import InfoCard from './InfoCard';

const StyledToggleButton = withStyles(theme => ({
    root: {
        height: '22px',
        fontSize: '10px',
        padding: '0 5px',
        textTransform: 'initial',
        borderColor: theme.palette.background.border,
        color: theme.palette.text.secondary
    },
    selected: {
        backgroundColor: `${theme.palette.background.border} !important`,
        color: `${theme.palette.text.primary} !important`
    }
}))(ToggleButton);

const areaUnitLabels = {
    'ha': 'Ha',
    'm2': 'm2',
    'acres': 'Acres',
    'sqft': 'sqft'
};

class AreaInfoCard extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        value: PropTypes.number,
        label: PropTypes.string,
        defaultAreaUnit: PropTypes.oneOf(['ha', 'm2', 'acres', 'sqft']),
        areaUnits: PropTypes.array,
        labelProps: PropTypes.object
    };

    static defaultProps = {
        label: 'Area',
        defaultAreaUnit: 'ha',
        areaUnits: ['ha', 'm2', 'acres'],
        labelProps: {}
    };

    constructor (props) {
        super(props);

        this.state = {
            areaUnit: props.defaultAreaUnit
        };

        this.handleAreaUnitChange = this.handleAreaUnitChange.bind(this);
        this.formatArea = this.formatArea.bind(this);
    }

    handleAreaUnitChange (event, newAreaUnit) {
        if (newAreaUnit) {
            this.setState({
                areaUnit: newAreaUnit
            });
        }
    }

    formatArea (value, areaUnit) {
        switch (areaUnit) {
            case 'ha':
                return value * 0.0001;
            case 'acres':
                return value * 0.000247105;
            case 'sqft':
                return value * 10.7639;
            default:
                return value;
        }
    }

    render () {
        const { classes, label, value, defaultAreaUnit, areaUnits, labelProps, ...otherProps } =this.props;
        const { areaUnit } = this.state;

        return (
            <InfoCard {...otherProps}>
                <Typography
                    className={classes.areaContainer}
                    component="div"
                    {...labelProps}
                >
                    {label}
                    {
                        <ToggleButtonGroup
                            classes={{
                                root: classes.toggleButtonGroup
                                // grouped: classes.toggleButton
                            }}
                            value={areaUnit}
                            exclusive
                            onChange={this.handleAreaUnitChange}
                        >
                            {
                                areaUnits.map(au =>
                                    <StyledToggleButton key={au} value={au}>
                                        {areaUnitLabels[au]}
                                    </StyledToggleButton>
                                )
                            }
                        </ToggleButtonGroup>
                    }
                </Typography>
                <Typography>
                    {value ? this.formatArea(value, areaUnit).toLocaleString(undefined, { maximumFractionDigits:2 }) : 'N/A'}
                </Typography>
            </InfoCard>
        );
    }
}

const style = theme => ({

    toggleButtonGroup: {
        backgroundColor: 'initial'
    },
    toggleButton: {
        height: '22px',
        fontSize: '10px',
        padding: '0 5px',
        textTransform: 'initial',
        borderColor: theme.palette.background.border,
        color: theme.palette.text.secondary
    },
    toggleButtonSelect: {
        backgroundColor: theme.palette.background.border,
        color: theme.palette.text.primary
    },
    areaContainer: {
        justifyContent: 'space-between'
    }
});

export default withStyles(style)(AreaInfoCard);